var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonUserManagement = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M8.94 15.057a8.057 8.057 0 1116.114 0 8.057 8.057 0 01-16.114 0z", fill: fills.dark }),
        React.createElement("path", { d: "M6.554 28.554A8.718 8.718 0 0112.72 26h8.554a8.718 8.718 0 018.72 8.72v1.738a3.496 3.496 0 01-3.495 3.495H7.495A3.496 3.496 0 014 36.458V34.72c0-2.312.918-4.531 2.554-6.167z", fill: fills.light }),
        React.createElement("path", { d: "M43.737 20.255a1.953 1.953 0 00-1.744-.972l-.002-.007a1.486 1.486 0 01-1.288-2.26l-.006-.007c.014-.021.03-.042.042-.066a1.95 1.95 0 00-3.37-1.963c-.015.024-.026.05-.038.073l-.01-.002a1.488 1.488 0 01-2.584.019c-.005-.007-.007-.014-.012-.024-.005 0-.01.003-.012.003-.014-.026-.023-.05-.037-.076a1.95 1.95 0 00-2.665-.71 1.95 1.95 0 00-.748 2.589c.021.03.04.058.059.089a1.488 1.488 0 01-1.248 2.234v.002c-.026-.002-.052-.005-.08-.005a1.95 1.95 0 00-.037 3.898l.077-.002v.002a1.489 1.489 0 011.292 2.276l.003.002-.043.064a1.95 1.95 0 003.37 1.963c.013-.021.022-.043.034-.064h.002a1.488 1.488 0 012.596-.04c.01.014.017.03.024.045h.005a1.95 1.95 0 103.373-1.947l.002-.002a1.485 1.485 0 011.273-2.186c0-.003 0-.003.002-.005a1.949 1.949 0 001.77-2.921zm-5.983 1.932a2.006 2.006 0 11-3.465-2.02 2.006 2.006 0 013.465 2.02z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
